// @flow strict
export { default } from './Pagination';
